<template>
    <div id="CodeExchange">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="full flex fc jc ac">
                        <img src="./img/close.png"
                             @click="close"
                             class="close" v-show="$route.path!='/reqrefund'" />
                        <div class="tab flex ac">
                            <div class="title"
                                 :class="active_tab==0?'active':''"
                                 @click="tab_change(0)">扫码登录</div>
                            <div class="title"
                                 :class="active_tab==1?'active':''"
                                 @click="tab_change(1)">手机号登录</div>
                        </div>
                        <template v-if="active_tab==0">
                            <div class="code_wrap">
                                <div class="tips">登录后即可开启MJ绘画</div>
                                <img :src="code_img_url" />
                                <div v-if="timerout" class="time_out_cover" flex-center @click="get_login_code"> 二维码已过期，点击刷新 </div>
                            </div>
                            <div class="login_tips flex jb ac">
                                <img src="./img/weixin.png"
                                     alt=" " />
                                <p>微信扫码“关注公众号”授权PC端登录</p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="form_item flex jb ac">
                                <el-input class="input" maxlength="11" v-model="phone" placeholder="请输入手机号"></el-input>
                                <span @click="send_code">{{time_space?`重新获取(${time_space})`:'发送验证码'}}</span>
                            </div>
                            <div class="form_item flex jb ac">
                                <el-input class="input" v-model="code" maxlength="6" placeholder="请输入验证码"></el-input>
                            </div>
                            <div class="btn"
                                 @click="bind_phone_code">登录</div>
                        </template>
                        <div class="agree">
                            <p>注册/登录表示您已同意<a target="_blank" href="https://docs.qq.com/doc/p/dab4e5845c5a3a8aadc6556fe9f6cc7803b7cb9b">《用户协议》</a>及<a target="_blank" href="https://docs.qq.com/doc/p/d5bc65c646ea1d70ec02ac7884c76ed274369512">《隐私政策》</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    data () {
        return {
            str_uuid: "",
            timer: null,
            code_img_url: '',
            active_tab: 0,
            phone: '',
            code: '',
            time_space: 0,
            msgtimer: null,
            can_phone_login: true,
            timerout:false,
            pay_time:0,
        }
    },
    created () {
        this.get_login_code()
    },
    methods: {
        get_login_code () {
            this.timerout = false
            this.pay_time = 0
            if(this.timer){
                clearInterval(this.timer)
            }
            let bd_vid = localStorage.getItem("bd_vid") || "";
            let qhclickid = localStorage.getItem("qhclickid") || "";
            let sourceid = localStorage.getItem("sourceid") || "";
            let href = location.href
            let ad_account_id = localStorage.getItem("ad_account_id") || 0;
            let site_id = localStorage.getItem("site_id") || 0;
            let timestamp = localStorage.getItem("timestamp") || 0;
            if (href.indexOf(API_SERVER) <= -1) {
                ad_account_id = ad_account_id || AD_AID
            }
            let keyword = localStorage.getItem("keyword") || "";
            let params = { ad_account_id: ad_account_id, site_id: site_id, keyword: keyword, bd_vid: bd_vid, qhclickid: qhclickid, sourceid: sourceid, timestamp: timestamp}
            this.$http.get(`/front/wx/imagecode/?authorizer_appid=${APP_ID}`, params).then(res => {
                if (res.status == '200') {
                    this.code_img_url = res.data.res_img
                    this.str_uuid = res.data.str_uuid;
                    this.getLoginInfo();
                }
            })
        },
        getLoginInfo () {
            this.timerout = false
            this.timer = setInterval(() => {
                let href = location.href
                let ad_account_id = this.getCache("ad_account_id") || 0
                let site_id = this.getCache("site_id") || 0
                let keyword = this.getCache("keyword") || ""
                let timestamp = localStorage.getItem("timestamp") || 0;

                if (href.indexOf(API_SERVER) <= -1) {
                    ad_account_id = ad_account_id || AD_AID
                }
                let params = { str_uuid:this.str_uuid, ad_account_id:ad_account_id, site_id: site_id, keyword: keyword,timestamp: timestamp }
                this.$http.get(`/front/wx/imagecodelogin/`, { params: params }).then((res) => {
                    if (res.data.is_auth_wxa == 1 && res.data.user_id && res.data.token) {
                        localStorage.setItem("token", res.data.token);
                        this.getProfile();
                        clearInterval(this.timer);
                        this.timer = null
                    }
                })
                this.pay_time += 3;
                if(this.pay_time >= 60){
                    this.pay_time = 0;
                    clearInterval(this.timer);
                    this.timerout = true;
                }
            }, 3000)
        },
        getProfile () {
            let invite_code = localStorage.getItem("invite_code") || "";
            this.$http.get(`/front/user/profile/`,{params:{invite_code:invite_code, app_id:APP_ID}}).then(res => {
                if (res.status == '200') {
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                    this.$store.commit('setShowLogin', false)
                    localStorage.setItem("userinfo", JSON.stringify(res.data));
                    localStorage.setItem("invite_code", res.data.invite_code);
                }
            }).finally(() => {

            })
        },
        close () {
            this.$store.commit('setShowLogin', false)
        },
        tab_change (type) {
            console.log("tab_change=", type)
            this.active_tab = type
            if(this.msgtimer)
                clearInterval(this.msgtimer);
            if(this.timer)
            clearInterval(this.timer);
            this.timer = null
            this.msgtimer = null;
            this.phone = ''
            this.code = ''
            if (type == 0) {
                this.get_login_code()
            }
        },
        check_phone (phone) {
            // 定义手机号码的正则表达式
            if(!phone){
                this.$toast("请填写手机号");
                return false;
            }
            const regex = /^1[3456789]\d{9}$/;
            if (!regex.test(phone)) {
                this.$toast("手机号码格式不正确");
                return false;
            } else {
                return true
            }
        },
        send_code () {
            if (this.time_space != 0) {
                return
            }
            let check_phone_res = this.check_phone(this.phone)
            if (!check_phone_res) {
                return
            }
            //如果手机号码校验通过
            this.$http.post(`/front/auth/smscode/`, {
                'phone':this.phone,
                'tpl_id':SMS_TPL_ID
            }).then(res => {
                if (res.status == '200') {
                    this.$toast("验证码已发送，请注意查收");
                    this.time_space = 60
                    this.msgtimer = setInterval(() => {
                        this.time_space--;
                        if (this.time_space === 0) {
                            clearInterval(this.msgtimer); // 清除定时器
                        }
                    }, 1000);
                }else{
                    this.$message({
                        message: res.message,
                        type: 'warning',
                    })
                }
            })
        },
        //手机号码登录
        bind_phone_code () {
            let check_phone_res = this.check_phone(this.phone)
            if (!check_phone_res) {
                return
            }
            if (!this.code.length) {
                this.$toast("验证码不得为空");
                return
            }
            if(this.code.length != 6){
                this.$message({
                    message:  "请输入6位验证码",
                    type: 'warning'
                });
                return false;
            }
            let ad_account_id = this.getCache("ad_account_id") || 0
            let site_id = this.getCache("site_id") || 0
            let keyword = this.getCache("keyword")||"";
            let data = {
                phone:this.phone,
                code:this.code,
                action:"autoreg",
                ad_account_id:ad_account_id,
                site_id:site_id,
                keyword:keyword
            }
            
            this.$http.post(`/front/auth/login/phone/code/`, data).then(res => {
                if (res.status == '200') {
                    this.$message({
                        message: '登录成功！',
                        type: 'success'
                    });
                    localStorage.setItem("token", res.data.token);
                    this.getProfile();
                    this.close()
                }else{
                    this.$message({
                        message: res.message,
                        type: 'warning',
                    })
                }
            }).catch(res => {
                this.$message({
                    message: res.message,
                    type: 'warning'
                });
            })
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#CodeExchange {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        border: 2px solid #5865f2;
        border-radius: 5px;
        overflow: hidden;
        .con {
            width: 290px;
            padding: 20px 20px 0;
            background-color: #1e1f22;
            max-width: 90vw;
            .full {
                position: relative;
                .close {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    width: 28px;
                    height: 28px;
                    padding: 6px;
                    cursor: pointer;
                }
                .tab {
                    padding: 25px 0 30px;
                    width: 100%;
                    .title {
                        text-align: center;
                        color: #b4b9bf;
                        font-size: 16px;
                        border-bottom: 2px solid #36373d;
                        cursor: pointer;
                        flex-grow: 1;
                        padding-bottom: 6px;
                        line-height: 1;
                        &.active {
                            color: #5865f2;
                            border-bottom: 2px solid #5865f2;
                        }
                    }
                }
                .code_wrap {
                    width: 230px;
                    height: 230px;
                    position: relative;
                    border-radius: 10px;
                    border: 6px solid #dcdcdc;
                    .tips {
                        font-size: 12px;
                        color: #fff;
                        padding: 8px 10px;
                        background-color: #5865f2;
                        position: absolute;
                        right: -32px;
                        top: 8px;
                        z-index: 20;
                        border-radius: 6px;
                        transform: translateY(-100%);
                        &:after {
                            content: "";
                            position: absolute;
                            width: 0;
                            height: 0;
                            border-top: 6px solid #5865f2;
                            border-right: 10px solid transparent;
                            border-left: 8px solid transparent;
                            border-bottom: 0 solid transparent;
                            top: 100%;
                            left: 10px;
                            transform: translateY(-1px);
                        }
                    }
                    .time_out_cover {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 5;
                        cursor: pointer;
                        background-color: rgba(0, 0, 0, 0.58);
                        color: #fff;
                        font-size: 15px;
                        z-index: 10;
                        &:hover{
                            font-size: 16px;
                            font-weight: bold;
                        }
                       
                    }
                }
                .form_item {
                    background: #2b2d31;
                    padding: 0 12px;
                    border: 2px solid #36373d;
                    border-radius: 8px;
                    height: 52px;
                    margin-bottom: 25px;
                    width: 100%;
                    /deep/.el-input__inner {
                        border: none;
                        background: transparent;
                        color: rgba(255, 255, 255, .78);
                        padding: 0;
                    }
                    span {
                        white-space: nowrap;
                        font-size: 14px;
                        color: #5865f2;
                        cursor: pointer;
                    }
                }
                .btn {
                    background: #5865f2;
                    padding: 0 12px;
                    border: 2px solid #5865f2;
                    border-radius: 8px;
                    height: 52px;
                    margin-top: 25px;
                    width: 250px;
                    font-size: 16px;
                    border-radius: 10px;
                    text-align: center;
                    line-height: 52px;
                    color: #fff;
                    cursor: pointer;
                }
                .login_tips {
                    margin-top: 20px;
                    font-size: 13px;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 5px;
                    }
                }
                .agree {
                    font-size: 12px;
                    color: #b4b9bf;
                    padding: 20px 0 10px;
                    white-space: nowrap;
                    text-align: center;
                    a {
                        color: #5865f2;
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>